import React from "react";
import "./Footer.css"

function Footer() {
    return (
      <footer className="rodape">
        <p>

        &#169;	Desenvolvido por Equipe WEB - Capítulo CS - Ramo Estudantil IEEE - CEFET/RJ
        </p>
      </footer>
    );
  }
  
export default Footer;